import { get, defaultTo, isFunction } from 'lodash/fp'

/**
 *
 * Improved getOr from lodash/fp
 *
 * const person = { name: null }
 *
 * const name1 = getOr('Dmytro', 'name', person)
 * const name2 = safeGetOr('Dmytro', 'name', person)
 *
 * console.log(name1)
 * // null
 * console.log(name2)
 * // 'Dmytro'
 *
 * @param defaultValue {*}
 * @param path {String | String[]}
 * @return {function(*=): *}
 */
export const safeGetOr = <TObject extends object, TKey extends keyof TObject, TDefault>(
  defaultValue: TDefault,
  path: TKey
) => {
  /**
   * @param object {*}
   *
   * @return {defaultValue | *}
   */
  return (object: TObject): TDefault | TObject[TKey] => {
    const value = get<TObject, TKey>(path, object)

    return defaultTo<TObject[TKey], TDefault>(defaultValue, value)
  }
}

const executeOrReturn = funcOrAny => argument => (isFunction(funcOrAny) ? funcOrAny(argument) : funcOrAny)

/**
 * @param condition {function | *}
 * @param onTrue {function | *}
 * @param onFalse {function | *}
 * @return {function(*=): *}
 */
export const ifElse = (condition, onTrue, onFalse = undefined) => {
  /**
   * @param object {*}
   *
   * @return {onTrue | onFalse | *}
   */
  return object => {
    const funcOrAnyToExecute = executeOrReturn(condition)(object) ? onTrue : onFalse

    return executeOrReturn(funcOrAnyToExecute)(condition)
  }
}

export const inverse = value => !value
export const atLeast = targetValue => value => (value > targetValue ? value : targetValue)
